module.exports = __webpack_public_path__ + "static/media/logoFooter.162d109e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logoFooter.png
// module id = 1144
// module chunks = 0